export function roundFloorToBucket(floor, bucketSize) {
  var remainder = floor % bucketSize;
  var floorBucketModifier = 0;

  if (remainder > 0) {
    floorBucketModifier = bucketSize - remainder;
  }

  return floor + floorBucketModifier;
}

// TODO: Higher floors for video
export function convertCpmToBucket(cpm, maxCPMFloor = 48.00) {
  var convertCPMToFloorTargeting = 100;
  var floor = Math.round(cpm * convertCPMToFloorTargeting);

  // Use buckets to accomodate limited pricing rules. Default max floor of $48.00 CPM.
  var bucketSize = 0.01;
  if (floor >= maxCPMFloor*100) {
    floor = maxCPMFloor*100;
  } else {
    if (floor <= 110) {
      bucketSize = 0.01;
    } else if (floor <= 250) {
      bucketSize = 0.05;
    } else if (floor <= 700) {
      bucketSize = 0.10;
    } else if (floor <= 900) {
      bucketSize = 0.25;
    } else if (floor <= 4800) {
      bucketSize = 4;
    } else {
      floor = 4800 // Max floor of $48.00 CPM
    }
  }

  var floorBucket = roundFloorToBucket(floor, bucketSize*100);

  return roundTwoDecimal(floorBucket/100);
}

export function roundTwoDecimal(num) {
  return Math.round((num + Number.EPSILON) * 100) / 100;
}

/*
 * Hash a number into a string using a secret sentence
 */
export function hashNumber(secretSentence, num) {
  var obfuscatedNum = [];
  var wholeNum = Math.round(num*100);
  wholeNum.toString().split('').forEach((char) => {
    obfuscatedNum.push(secretSentence[parseInt(char)]);
  })

  return obfuscatedNum.join('');
}

export function getBrowserName(userAgent) {
  let browserName = "Unknown";

  if (userAgent.match(/chrome|chromium|crios/i)) {
    browserName = "Chrome";
  } else if (userAgent.match(/firefox|fxios/i)) {
    browserName = "Firefox";
  } else if (userAgent.match(/safari/i)) {
    browserName = "Safari";
  } else if (userAgent.match(/opr\//i)) {
    browserName = "Opera";
  } else if (userAgent.match(/edg/i)) {
    browserName = "Edge";
  } else if (userAgent.match(/trident/i)) {
    browserName = "Internet Explorer";
  }

  return browserName;
}
